export const pluginConfig = {
  lang: 'en',
  position: 'bottom-left',
  offset: [20, 20],
  size: 58,
  stylesheet: null as string | null,
  color: null as string | null
};